class FoldUpText extends HTMLElement {
  constructor() {
    super();
    this.moreButton = this.querySelector('.more-button');
    this.content = this.querySelector('.content');
    
    if (!this.moreButton || !this.content) return;
    
    this.init();
  }

  init() {
    this.moreButton.addEventListener('click', this.handleClick.bind(this));
    this.setupAccessibility();
  }

  setupAccessibility() {
    const isExpanded = this.content.classList.contains('full');
    this.moreButton.setAttribute('aria-expanded', isExpanded);
  }

  handleClick() {
    const isExpanded = this.content.classList.contains('full');
    
    if (isExpanded) {
      this.scrollToComponent();
      
      this.content.classList.remove('full');
      this.moreButton.setAttribute('aria-expanded', 'false');
    } else {
      this.content.classList.add('full');
      this.moreButton.setAttribute('aria-expanded', 'true');
    }
  }

  scrollToComponent() {
    const rect = this.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const componentTop = rect.top + scrollTop;
    
    window.scrollTo({
      top: componentTop,
      behavior: 'smooth'
    });
  }
}

if (!customElements.get('fold-up-text')) {
  customElements.define('fold-up-text', FoldUpText);
}
